module.exports = __webpack_public_path__ + "img/four-seven.cddde081.png";